import React from 'react';
import { HeaderProps } from './headerProps';
import { Container } from './headerStyles';

export const Header = ({ children }: HeaderProps) => {
  return <Container>{children}</Container>;
};
